import React, { useState, useEffect, useContext } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import Swal from "sweetalert2";
import Card from "react-bootstrap/Card";
import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";
import Container from "react-bootstrap/Container";
import Button from "react-bootstrap/Button";
import Collapse from "react-bootstrap/Collapse";
import Form from "react-bootstrap/Form";
import Badge from "react-bootstrap/Badge";
import Select from "react-select";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
    faCheckCircle,
    faTimesCircle,
    faPrint,
    faUser,
    faCreditCard,
    faMoneyBillWave,
    faCalendarAlt,
    faUniversity,
    faTags,
    faReceipt,
    faCalculator,
    faInfoCircle,
    faSyncAlt,
    faChevronDown,
    faChevronUp,
    faIdCard,
    faGraduationCap,
    faPercent,
    faRupeeSign,
    faEnvelope,
    faPhone
} from "@fortawesome/free-solid-svg-icons";
import { ProductContext } from "../context/AppContext";
import { KJUR } from "jsrsasign";
import Header from "./Header";

const AdmissionFees = () => {
    const navigate = useNavigate();
    const { state } = useLocation();
    const authtoken = localStorage.getItem("token");
    const { userData, GetstudentData, Automationdata } = useContext(ProductContext);
    const schema = userData?.currentUser?.schema;

    const studentId = GetstudentData?.regs_id;
    const studentName = GetstudentData?.student_full_name;
    const sessionId = GetstudentData?.session;
    const classSectionId = GetstudentData?.class_section_id;
    const streamId = GetstudentData?.stream_id;
    // const classSectionName = GetstudentData?.cls_sec?.cls?.Classes || GetstudentData?.cls_sec?.section?.section;
    const classSectionName = `${GetstudentData?.cls_sec?.cls?.Classes || ''} ${GetstudentData?.cls_sec?.section?.section || ''}`.trim();
    const StudentMobile = GetstudentData?.contact_phone;
    const StudentEmail = GetstudentData?.contact_email;


    const sessionName = GetstudentData?.id;
    const discountTypeId = GetstudentData?.id;
    const streamName = GetstudentData?.stream_id;
    const discountTypeName = GetstudentData?.id;
    const discountValue = GetstudentData?.id;
    const feeCategoryName = GetstudentData?.id;
    const discountMode = GetstudentData?.id;
    const discountedValue = GetstudentData?.id;
    const feeCategoryId = GetstudentData?.id;
    


    const [formData, setFormData] = useState({
        fee_cycle_id: "",
        amount_due: 0,
        amount_paid: 0,
        discount_applied: 0,
        fine_applied: 0,
        amount_balanced: 0,
        payment_method: "",
        account_id: "",
        remarks: "",
        submission_date: new Date().toISOString().split("T")[0],
        cheque_no: "",
        cheque_transaction_date: "",
        cheque_bank: "",
        branch_name: "",
        online_method: "",
        transaction_no: "",
        invoice_no: "",
        batch_no: "",
        reference_no: "",
        email: "",
        phone: "",
    });

    const [paymentType, setPaymentType] = useState("offline");

    const [collapsed, setCollapsed] = useState({
        studentDetails: false,
        paymentDetails: false,
    });

    const [loading, setLoading] = useState(false);
    const [feeCycles, setFeeCycles] = useState([]);
    const [banks, setBanks] = useState([]);
    const [admissionFee, setAdmissionFee] = useState(null);
    const [phoneError, setPhoneError] = useState("");

    // Generate JWT Token
    const generateJwtToken = (schema) => {
        const header = { alg: "HS256", typ: "JWT" };
        const payload = {
            schema: schema,
            exp: Math.floor(Date.now() / 1000) + (30 * 60),
        };
        const sHeader = JSON.stringify(header);
        const sPayload = JSON.stringify(payload);
        const token = KJUR.jws.JWS.sign("HS256", sHeader, sPayload, "token");
        return token;
    };

    // Fetch admission fee
    const fetchAdmissionFee = async () => {
        if (!classSectionId) return;
        try {
            const ctgryId = state?.ctgry_id || GetstudentData?.ctgry_id;
            const sessId = state?.session || sessionId;
            const response = await fetch(`https://api.mirai.healthcare/api/fee-service/fee-categories/addmission?class_section_id=${classSectionId}&session_id=${sessId}&student_category_id=${ctgryId}`, {
                method: "GET",
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json",
                    "x-auth": authtoken,
                },
            });
            if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
            const data = await response.json();
            if (Array.isArray(data) && data.length > 0) {
                setAdmissionFee(data[0]);
                const amount = parseFloat(data[0].fee_config?.amount) || 0;
                setFormData((prev) => ({
                    ...prev,
                    amount_due: amount,
                    amount_paid: amount,
                    amount_balanced: 0,
                }));
            }
        } catch (error) {
            console.error("Fetch admission fee error:", error);
            Swal.fire({
                icon: "error",
                title: "Error",
                text: "Failed to fetch admission fee.",
                confirmButtonColor: "#ec4899",
            });
        }
    };

    // Fetch fee cycles from API
    const fetchFeeCycles = async () => {
        try {
            const response = await fetch("https://api.mirai.healthcare/api/fee-service/fee-cycles", {
                method: "GET",
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json",
                    "x-auth": authtoken,
                },
            });
            if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
            const data = await response.json();
            if (Array.isArray(data)) {
                const filteredCycles = data
                    .filter((cycle) => cycle.session_id === sessionId && cycle.status === "Active" && !cycle.is_deleted)
                    .map((cycle) => ({
                        value: cycle.id,
                        label: cycle.name,
                    }));
                setFeeCycles(filteredCycles);
            } else {
                throw new Error("Invalid fee cycles data structure");
            }
        } catch (error) {
            console.error("Fetch fee cycles error:", error);
            Swal.fire({
                icon: "error",
                title: "Error",
                text: "Failed to fetch fee cycles.",
                confirmButtonColor: "#ec4899",
            });
            setFeeCycles([]);
        }
    };

    // Fetch banks for Select Account and Select Cheque Bank dropdowns
    const fetchBanks = async () => {
        try {
            const response = await fetch("https://api.mirai.healthcare/api/fee-service/bank?is_school_bank=true", {
                method: "GET",
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json",
                    "x-auth": authtoken,
                },
            });
            if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
            const data = await response.json();
            if (data.success && Array.isArray(data.message)) {
                const formattedBanks = data.message
                    .filter((bank) => bank.is_school_bank && !bank.is_deleted)
                    .map((bank) => ({
                        value: bank.id,
                        label: bank.name,
                    }));
                setBanks(formattedBanks);
            } else {
                throw new Error("Invalid banks data structure");
            }
        } catch (error) {
            console.error("Fetch banks error:", error);
            setBanks([
                { value: 1, label: "State Bank of India" },
                { value: 2, label: "Punjab National Bank" },
            ]);
            Swal.fire({
                icon: "error",
                title: "Error",
                text: "Failed to fetch bank details.",
                confirmButtonColor: "#ec4899",
            });
        }
    };

    useEffect(() => {
        if (sessionId) {
            fetchFeeCycles();
            fetchBanks();
        }
        if (classSectionId) {
            fetchAdmissionFee();
        }
        setFormData((prev) => ({
            ...prev,
            amount_due: 0,
            amount_paid: 0,
            amount_balanced: 0,
        }));
    }, [sessionId, classSectionId]);

    const toggleCollapse = (section) => {
        setCollapsed((prev) => ({ ...prev, [section]: !prev[section] }));
    };

    const handleChange = (field, value) => {
        setFormData((prev) => {
            let updatedFormData = { ...prev, [field]: value };

            // Calculate amount_balanced
            if (field === "amount_due" || field === "amount_paid" || field === "discount_applied" || field === "fine_applied") {
                const amountDue = parseFloat(updatedFormData.amount_due) || 0;
                const amountPaid = parseFloat(updatedFormData.amount_paid) || 0;
                const discountApplied = parseFloat(updatedFormData.discount_applied) || 0;
                const fineApplied = parseFloat(updatedFormData.fine_applied) || 0;
                updatedFormData.amount_balanced = amountDue - amountPaid - discountApplied + fineApplied;
            }

            // Clamp amount_paid to not exceed (amount_due + fine_applied - discount_applied)
            if (field === "amount_paid") {
                const maxAllowed = parseFloat(updatedFormData.amount_due) + parseFloat(updatedFormData.fine_applied) - parseFloat(updatedFormData.discount_applied);
                const clampedValue = Math.min(parseFloat(value) || 0, maxAllowed);
                updatedFormData[field] = clampedValue;

                // Recalculate balanced after clamping
                updatedFormData.amount_balanced = updatedFormData.amount_due - clampedValue - updatedFormData.discount_applied + updatedFormData.fine_applied;
            }

            return updatedFormData;
        });
    };

    

    console.log(admissionFee?.id, "admissionFee?.id  chedck data")

//     const handleSubmit = async (e) => {
//   e.preventDefault();
//   setLoading(true);
//   setPhoneError("");

//   const currentFeeCategoryId = admissionFee?.id;
//   const currentDiscountedValue = parseFloat(formData.amount_due) || 0;
//   const amountToPay = parseFloat(formData.amount_paid) || 0;
//   const isOnlinePayment = paymentType === "payu" || paymentType === "copy_link";

//   const feeCollPayload = {
//     session_id: sessionId,
//     student_id: studentId,
//     class_section_id: classSectionId,
//     stream_id: streamId || 0,
//     discount_type_id: parseInt(discountTypeId) || 0,
//     discounted_value: currentDiscountedValue,
//     special_discounted_value: 0,
//     fee_category_id: currentFeeCategoryId,
//     fee_cycle_id: formData.fee_cycle_id,
//     amount_due: parseFloat(formData.amount_due) || 0,
//     amount_paid: isOnlinePayment ? 0 : amountToPay,
//     discount_applied: parseFloat(formData.discount_applied) || 0,
//     fine_applied: parseFloat(formData.fine_applied) || 0,
//     amount_balanced: isOnlinePayment
//       ? parseFloat(formData.amount_due) - parseFloat(formData.discount_applied) + parseFloat(formData.fine_applied)
//       : parseFloat(formData.amount_balanced) || 0,
//     payment_mode: "Payu",
//     payment_date: formData.submission_date,
//     reference_no: "",
//     remarks: "",
//     fee_month: 0,
//   };

//   const payload = {
//     fee_cycle_id: parseInt(formData.fee_cycle_id),
//     fee_coll: feeCollPayload,
//   };

//   // 👉 OPEN BLANK TAB FIRST (to bypass popup blocking)
//   let paymentWindow = null;
//   if (paymentType === "payu") {
//     paymentWindow = window.open("", "_blank");
//   }

//   try {
//     const patchResponse = await fetch(`https://api.mirai.healthcare/api/register/admission/${studentId}`, {
//       method: "PATCH",
//       headers: {
//         Accept: "application/json",
//         "Content-Type": "application/json",
//         "x-auth": authtoken,
//       },
//       body: JSON.stringify(payload),
//     });

//     const patchData = await patchResponse.json();
//     const feeCollId = patchData?.data?.data?.fee_coll?.id;

//     await handlePaymentOnline(feeCollId);

//   } catch (error) {
//     console.error("Submit error:", error);
//     Swal.fire({
//       icon: "error",
//       title: "Error",
//       text: error.message || "Failed to submit fee collection or update admission.",
//       confirmButtonColor: "#ec4899",
//     });
//   } finally {
//     setLoading(false);
//   }
// };

// const handlePaymentOnline = async (feeCollId) => {
 
//   try {
//     const amountToPay = parseFloat(formData.amount_paid) || 0;

//     // ✅ Generate PayU URL first
//     const queryParams = new URLSearchParams({
//       amount: amountToPay,
//       productinfo: "Admission Fee Collection",
//       firstname: studentName,
//       email: StudentEmail,
//       phone: StudentMobile,
//       sessionId: sessionId,
//       studentId: studentId,
//       feeCollectionIds: feeCollId,  
//       authToken: authtoken,
      
//     });

//     const paymentUrl = `${window.location.origin}/pay-u-payment?${queryParams.toString()}`;

//     // ✅ Open payment page in new tab
//     const paymentWindow = window.open(paymentUrl, "_blank");


//     Swal.fire({
//       icon: "success",
//       title: "Payment Initiated",
//       text: "Please complete the payment in the new tab.",
//       confirmButtonColor: "#ec4899",
//     });
//   } catch (error) {
//     Swal.fire({
//       icon: "error",
//       title: "Error",
//       text: error.message || "Failed to initiate payment.",
//       confirmButtonColor: "#ec4899",
//     });
//   } finally {
//     setLoading(false);
//   }
// };

const handleSubmit = async (e) => {
  e.preventDefault();
  setLoading(true);
  setPhoneError("");

  try {
    const currentFeeCategoryId = admissionFee?.id;
    const currentDiscountedValue = parseFloat(formData.amount_due) || 0;
    const amountToPay = parseFloat(formData.amount_paid) || 0;
    const isOnlinePayment = paymentType === "payu" || paymentType === "copy_link";

    // ✅ Open blank window early (browser-safe)
    let paymentWindow = null;
    if (paymentType === "payu") {
      paymentWindow = window.open("", "_blank");
    }

    // ✅ Prepare payload
    const feeCollPayload = {
      session_id: sessionId,
      student_id: studentId,
      class_section_id: classSectionId,
      stream_id: streamId || 0,
      discount_type_id: parseInt(discountTypeId) || 0,
      discounted_value: currentDiscountedValue,
      special_discounted_value: 0,
      fee_category_id: currentFeeCategoryId,
      fee_cycle_id: formData.fee_cycle_id,
      amount_due: parseFloat(formData.amount_due) || 0,
      amount_paid: isOnlinePayment ? 0 : amountToPay,
      discount_applied: parseFloat(formData.discount_applied) || 0,
      fine_applied: parseFloat(formData.fine_applied) || 0,
      amount_balanced: isOnlinePayment
        ? parseFloat(formData.amount_due) - parseFloat(formData.discount_applied) + parseFloat(formData.fine_applied)
        : parseFloat(formData.amount_balanced) || 0,
      payment_mode: Automationdata?.data?.[0]?.PaymentMethod === "SabPaisa" ? "SabPaisa" : "Payu",
      payment_date: formData.submission_date,
      reference_no: "",
      remarks: "",
      fee_month: 0,
    };

    const payload = {
      fee_cycle_id: parseInt(formData.fee_cycle_id),
      fee_coll: feeCollPayload,
    };

    // ✅ Step 1: Call PATCH API to update admission
    const patchResponse = await fetch(
      `https://api.mirai.healthcare/api/register/admission/${studentId}`,
      {
        method: "PATCH",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          "x-auth": authtoken,
        },
        body: JSON.stringify(payload),
      }
    );

    const patchData = await patchResponse.json();

    if (!patchResponse.ok || !patchData.success) {
      throw new Error(patchData.message || "Failed to update admission before payment.");
    }

    // ✅ Extract feeCollId from API response
    const feeCollId = patchData?.data?.data?.fee_coll?.id;
    if (!feeCollId) {
      throw new Error("Fee Collection ID not found in API response.");
    }

    // ✅ Step 2: Redirect to payment page
    const queryParams = new URLSearchParams({
      amount: amountToPay,
      productinfo: "Admission Fee Collection",
      firstname: studentName,
      email: StudentEmail,
      phone: StudentMobile,
      sessionId: sessionId,
      studentId: studentId,
      feeCollectionIds: feeCollId,
      authToken: authtoken,
      paymentMethod: Automationdata?.data?.[0]?.PaymentMethod,
    });

    const paymentUrl = `${window.location.origin}/pay-u-payment?${queryParams.toString()}`;

    // ✅ Step 3: Show alert + redirect pre-opened window
    await Swal.fire({
      icon: "success",
      title: "Payment Initiated",
      text: "Redirecting you to the payment page...",
      showConfirmButton: false,
      timer: 1500,
    });

    if (paymentWindow) {
      paymentWindow.location.href = paymentUrl;
    } else {
      window.open(paymentUrl, "_blank");
    }

  } catch (error) {
    console.error("Submit error:", error);
    Swal.fire({
      icon: "error",
      title: "Error",
      text: error.message || "Something went wrong during payment initiation.",
      confirmButtonColor: "#ec4899",
    });
  } finally {
    setLoading(false);
  }
};


    const maxPaid = parseFloat(formData.amount_due) + parseFloat(formData.fine_applied) - parseFloat(formData.discount_applied);

    return (
        <div className="page-wrapper">
            {/* <div className="content"> */}
                <Header />
                <div className="content mt-2">
        <h3 className="page-title">Admission Fee Collection</h3>
        <p className="mb-0">
                                                Complete the admission process by collecting the required fees
                                            </p>
                                            <style>
                    {`
                        .bg-gradient-primary {
                            background: linear-gradient(135deg, #667eea 0%, #764ba2 100%) !important;
                        }
                        .bg-gradient-info {
                            background: linear-gradient(135deg, #f093fb 0%, #f5576c 100%) !important;
                        }
                        .bg-light-custom {
                            background-color: #f8f9fa !important;
                        }
                        .card-hover {
                            transition: transform 0.2s ease-in-out, box-shadow 0.2s ease-in-out;
                        }
                        .card-hover:hover {
                            transform: translateY(-2px);
                            box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1) !important;
                        }
                        .icon-container {
                            width: 50px;
                            height: 50px;
                            border-radius: 12px;
                            display: flex;
                            align-items: center;
                            justify-content: center;
                            margin-right: 15px;
                        }
                        .amount-display {
                            font-size: 1.5rem;
                            font-weight: 700;
                            color: #2d3748;
                        }
                        .form-section {
                            border-left: 4px solid #667eea;
                            padding-left: 15px;
                            margin-bottom: 25px;
                        }
                    `}
                </style>
                

                <Container fluid className="py-4">
                    {/* Header Section */}
                    

                    <Form onSubmit={handleSubmit}>
                        <Row>
                            {/* Student Information Column */}
                            <Col lg={4} className="mb-4">
                                <Card className="h-100 border-0 shadow-sm card-hover">
                                    <Card.Header className="bg-primary text-white py-3">
                                        <h5 className="mb-0 text-white">
                                            <FontAwesomeIcon icon={faUser} className="me-2" />
                                            Student Information
                                        </h5>
                                    </Card.Header>
                                    <Card.Body className="p-4">
                                        <div className="student-info-grid">
                                            <div className="d-flex align-items-center mb-3 p-3 bg-light-custom rounded">
                                                <div className="icon-container bg-primary text-white">
                                                    <FontAwesomeIcon icon={faIdCard} />
                                                </div>
                                                <div>
                                                    <small className="text-muted d-block">Student ID</small>
                                                    <strong>{studentId || "N/A"}</strong>
                                                </div>
                                            </div>

                                            <div className="d-flex align-items-center mb-3 p-3 bg-light-custom rounded">
                                                <div className="icon-container bg-info text-white">
                                                    <FontAwesomeIcon icon={faGraduationCap} />
                                                </div>
                                                <div>
                                                    <small className="text-muted d-block">Student Name</small>
                                                    <strong>{studentName || "N/A"}</strong>
                                                </div>
                                            </div>

                                            <div className="d-flex align-items-center mb-3 p-3 bg-light-custom rounded">
                                                <div className="icon-container bg-warning text-white">
                                                    <FontAwesomeIcon icon={faUniversity} />
                                                </div>
                                                <div>
                                                    <small className="text-muted d-block">Class & Section</small>
                                                    <strong>{classSectionName || "N/A"}</strong>
                                                </div>
                                            </div>

                                            {streamName && (
                                                <div className="d-flex align-items-center mb-3 p-3 bg-light-custom rounded">
                                                    <div className="icon-container bg-secondary text-white">
                                                        <FontAwesomeIcon icon={faUniversity} />
                                                    </div>
                                                    <div>
                                                        <small className="text-muted d-block">Stream</small>
                                                        <strong>{streamName}</strong>
                                                    </div>
                                                </div>
                                            )}

                                            <div className="d-flex align-items-center mb-3 p-3 bg-light-custom rounded">
                                                <div className="icon-container bg-danger text-white">
                                                    <FontAwesomeIcon icon={faTags} />
                                                </div>
                                                <div>
                                                    <small className="text-muted d-block">Discount Applied</small>
                                                    <strong>
                                                        {discountTypeName} ({discountMode === 'Percentage' ? `${discountValue}%` : `₹${discountValue}`})
                                                    </strong>
                                                </div>
                                            </div>
                                        </div>
                                    </Card.Body>
                                </Card>
                            </Col>

                            {/* Payment Form Column */}
                            <Col lg={8}>
                                <Card className="border-0 shadow-sm card-hover">
                                    <Card.Header className="bg-primary text-white py-3">
                                        <h5 className="mb-0 text-white">
                                            <FontAwesomeIcon icon={faCreditCard} className="me-2" />
                                            Payment Details
                                        </h5>
                                    </Card.Header>
                                    <Card.Body className="p-4">
                                        <Row className="g-3">
                                            {/* Fee Cycle */}
                                            <Col md={6}>
                                                <Form.Group>
                                                    <Form.Label className="fw-semibold">
                                                        <FontAwesomeIcon icon={faCalendarAlt} className="me-2 text-primary" />
                                                        Fee Cycle *
                                                    </Form.Label>
                                                    <Select
                                                        classNamePrefix="react-select"
                                                        options={feeCycles}
                                                        value={feeCycles.find((opt) => opt.value === formData.fee_cycle_id)}
                                                        onChange={(selected) => handleChange("fee_cycle_id", selected?.value || "")}
                                                        placeholder="Select Fee Cycle"
                                                        className="border rounded-3"
                                                    />
                                                </Form.Group>
                                            </Col>

                                            {/* Payment Type */}
                                            <Col md={6}>
                                                <Form.Group>
                                                    <Form.Label className="fw-semibold">
                                                        <FontAwesomeIcon icon={faCreditCard} className="me-2 text-info" />
                                                        Payment Type *
                                                    </Form.Label>
                                                    <Form.Control
                                                        type="tel"
                                                        value="online"
                                                        placeholder="Payment Type"
                                                        className={`border rounded-3 ${phoneError ? 'is-invalid' : ''}`}
                                                        disabled
                                                    />
                                                </Form.Group>
                                            </Col>

                                            {/* Amount Summary */}
                                            <Col md={6}>
                                                <div className="p-3 bg-light-custom rounded-3 border">
                                                    <div className="d-flex justify-content-between align-items-center mb-2">
                                                        <span className="text-muted">Amount Due:</span>
                                                        <span className="amount-display text-primary">
                                                            ₹{formData.amount_due || 0}
                                                        </span>
                                                    </div>
                                                    <div className="d-flex justify-content-between align-items-center mt-2">
                                                        <span className="fs-4 fw-bold">Balance:</span>
                                                        <span
                                                            className={`fs-4 fw-bold ${formData.amount_balanced >= 0 ? "text-success" : "text-danger"
                                                                }`}
                                                        >
                                                            ₹{formData.amount_balanced || 0}
                                                        </span>
                                                    </div>


                                                </div>
                                            </Col>

                                            {/* Amount Fields */}
                                            <Col md={4}>
                                                <Form.Group>
                                                    <Form.Label className="fw-semibold">
                                                        <FontAwesomeIcon icon={faRupeeSign} className="me-2 text-success" />
                                                        Amount Paid
                                                    </Form.Label>
                                                    <Form.Control
                                                        type="number"
                                                        value={formData.amount_paid}
                                                        onChange={(e) => handleChange("amount_paid", e.target.value)}
                                                        className="border rounded-3"
                                                        max={maxPaid}
                                                        min={0}
                                                    />
                                                </Form.Group>
                                            </Col>

                                        </Row>

                                        {/* Action Buttons */}
                                        <Row className="mt-4">
                                            <Col className="d-flex justify-content-between align-items-center">
                                                

                                                <div>
                                                    <Button
                                                        variant="outline-danger"
                                                        onClick={() => navigate("/")}
                                                        disabled={loading}
                                                        className="rounded-pill px-4 me-2"
                                                    >
                                                        <FontAwesomeIcon icon={faTimesCircle} className="me-2" />
                                                        Cancel
                                                    </Button>

                                                    <Button
                                                        variant="primary"
                                                        type="submit"
                                                        disabled={loading}
                                                        className="rounded-pill px-4"
                                                    >
                                                        <FontAwesomeIcon icon={faCheckCircle} className="me-2" />
                                                        {loading ? "Processing..." : "Submit Payment"}
                                                    </Button>
                                                </div>
                                            </Col>
                                        </Row>
                                    </Card.Body>
                                </Card>
                            </Col>
                        </Row>
                    </Form>
                </Container>
            </div>
        </div>
    );
};

export default AdmissionFees
